import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';

@Component({
  moduleId: module.id,
  selector: 'signature-redirect',
  template: '',
})
export class SignatureRedirectComponent implements OnInit {
  constructor(
    private amorphicService: AmorphicService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      const urlParams = new URLSearchParams(window.location.search);
      const queryParams = {};
      if (urlParams.get('event') === 'signing_complete') {
        queryParams['owner-sign-complete'] = '1';
      }

      if (params['applicationNumber']) {
        queryParams['applicationNumber'] = params['applicationNumber'];
        this.router.navigate(['/account-center-detailed-view'], { queryParams });
      } else {
        this.router.navigate(['/account-center'], { queryParams });
      }
    });
  }
}
